import {takeEvery,call,put,delay} from 'redux-saga/effects'
import {notification,message} from 'antd'
import firebaseApp from '../firebase'
import firebase  from 'firebase'







const db = firebaseApp.firestore();
const getUserDataAsync = (id)=>{
    var data =  db.collection("users").doc(id).get().then((docRef) => { 
    return docRef.data();
})
return data;
}


function* getUserData(action){
    const data = yield call(getUserDataAsync,action.payload)
    if(data){
        yield put({type:"SET_USER",payload:data})
          if(!data.verified){
            notification.warn({
                message: 'Your Profile is not verified',
                description:
                  'Update your profile to 100% and get extra 500 Bonus Points',
                  
                onClick: () => {
                  notification.destroy()
                },
                placement:"bottomRight"
              });
          }
      }
      
}

function* updateUserProfile(action){
  const newProfile = action.payload
  const user = firebase.auth().currentUser
  const key = "updatable"
  
    message.loading({ content: 'Verifying Phone Number...', key });
      user.updatePhoneNumber(newProfile.phoneCredential).then(function(){
        
        
        db.collection("users").doc(newProfile.uid).update({
          email:newProfile.email,
          phoneNumber:newProfile.number,
          displayName:newProfile.displayName,
          verified:true,
          coins:firebase.firestore.FieldValue.increment(500)
        }).then(function(){
          message.success({ content: 'Verified!', key, duration: 2 });
          notification.success({
            message: 'Your Profile is now verified',
            description:
              'You got 500 extra bonus coins ! Click here to reflect changes',
              
            onClick: () => {
              notification.destroy()
            },
            placement:"bottomRight"
          });
         setTimeout(()=>{
          window.location.reload();
         },2000)
        })
      }).catch(error=>{
       
       message.error({ content: error.message, key, duration: 3 });
      })
}
const updateReferal=(payload)=>{
  console.log(payload)
  const key = "updatable"
  var response = null;
  message.loading({ content: 'Updating Referrals Data', key });
 response = db.collection("users").doc(payload.my).update({
    coins:firebase.firestore.FieldValue.increment(500),
    refferedBy:payload.by
  }).then(()=>{
    db.collection("users").doc(payload.by).update({
      coins:firebase.firestore.FieldValue.increment(500),
      referrals:firebase.firestore.FieldValue.arrayUnion(payload.my)
    }).then(()=>{
      message.success({ content: 'Coins Added', key, duration: 2 });
      return true;
    }).catch((error)=>{
      message.error(error)
    return false;
    })
  })
  return response;
}
  
function* initiateRefer(action){
  //Did two things update the {payload.by} referals array
  // and update the refferedBy of {payload.my}
  const payload = action.payload
  yield call(updateReferal,payload)
  yield put({type:"GET_USER_DATA",payload:action.payload.my})

}
export default function* userSaga(){
    yield takeEvery("GET_USER_DATA",getUserData)
    yield takeEvery("UPDATE_USER_PROFILE",updateUserProfile)
    yield takeEvery("REFER_REQUEST",initiateRefer)
}